export enum TipTapImageSource {
  UPLOAD = "upload",
  GALLERY = "gallery"
}
